import { message } from "antd";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import firebaseConfig from "../Firebase/Firebase";

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Register the FCM service worker so getToken() has an active worker to use.
// Without this, getToken() fails with "no active Service Worker" (push needs a
// registered SW), which breaks login/OTP flows that require a notification token.
const registerMessagingSW = async () => {
  if (!("serviceWorker" in navigator)) return undefined;
  try {
    return await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  } catch (e) {
    return undefined;
  }
};

export const getFCMToken = async () => {
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    const serviceWorkerRegistration = await registerMessagingSW();
    const token = await getToken(messaging, {
      vapidKey:
        "BKf54fPlTtXYYcK0couG03moooQYQPe_z9a0ObiGLMIQDbqz4JPMLYks7ZoSDAXT0ZkKf6JnjwhzY1sEwkd9EPU",
      ...(serviceWorkerRegistration ? { serviceWorkerRegistration } : {}),
    });
    return token;
  } else if (permission === "denied") {
    message.error(`Notification Permission: ${permission}`);
  } else {
    message.error(`Notification Permission: ${permission}`);
  }
};
